import React, { useState } from 'react';
import { Sun, Moon, Check, Palette } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { useAppearance } from '../../theme/ThemeContext';

export default function AppearanceSettingCard() {
  const { theme, saving, changeTheme } = useAppearance();
  const { i18n } = useTranslation();
  const en = i18n.language?.startsWith('en');
  const [error, setError] = useState('');
  const choose = async value => {
    setError('');
    try { await changeTheme(value); }
    catch { setError(en ? 'Could not save appearance. Please try again.' : 'Kunde inte spara utseendet. Försök igen.'); }
  };
  return (
    <Card className="bg-card border-border" data-testid="appearance-settings">
      <CardHeader>
        <CardTitle className="font-heading flex items-center gap-2"><Palette className="w-4 h-4 text-primary" />{en ? 'Appearance' : 'Utseende'}</CardTitle>
        <p className="text-sm text-muted-foreground">{en ? 'Choose light or dark appearance for the app. Your choice is saved to your account.' : 'Välj ljust eller mörkt utseende för appen. Valet sparas på ditt konto.'}</p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3 max-w-md" role="group" aria-label={en ? 'Appearance' : 'Utseende'} aria-busy={saving}>
          {[['light', Sun, en ? 'Light' : 'Ljust'], ['dark', Moon, en ? 'Dark' : 'Mörkt']].map(([value, Icon, label]) => (
            <button key={value} type="button" disabled={saving} aria-pressed={theme === value} onClick={() => choose(value)}
              data-testid={`appearance-${value}`}
              className={`flex min-h-[48px] items-center gap-2 rounded-xl border px-4 py-3 text-sm font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-60 ${theme === value ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-background text-foreground hover:bg-muted'}`}>
              <Icon className="h-4 w-4 shrink-0" /><span>{label}</span>{theme === value && <Check className="ml-auto h-4 w-4" />}
            </button>
          ))}
        </div>
        <p role="status" className="mt-2 text-xs text-muted-foreground">{saving ? (en ? 'Saving…' : 'Sparar…') : ''}</p>
        {error && <p role="alert" className="mt-2 text-sm text-destructive">{error}</p>}
      </CardContent>
    </Card>
  );
}
